<template>
  <vx-card class="training-file-card">
    <vs-button v-if="enableEdit" radius color="danger" type="flat" icon="close" class="delete-button" @click="$emit('delete')"></vs-button>
    <p>{{ name }}</p>
    <vs-button v-if="url" radius color="primary" type="flat"  icon="icon-download" icon-pack="feather" :href="url"></vs-button>
  </vx-card>
</template>


<script>
export default {
  name: "FilesCard",
  props: {
    enableEdit: {type: Boolean, default: false},
    url: {type: String, default: null},
    name: {type: String, default: 'Filename'},
  }
}
</script>

<style lang="scss">
.training-file-card {
  position: relative;
  .delete-button {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}

</style>
